import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ILocalization } from 'bernie-l10n';

import { UitkButtonSize, UitkFloatingFullWidthButton } from 'uitk-react-button';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';

const UitkFloatingFullWidthButtonTracked = ClickTracker(UitkFloatingFullWidthButton);

export interface HoldingAreaActionsProps {
  goToCheckout: () => void;
  l10n: ILocalization;
  isAllSoldOut: () => boolean;
  isNotFullCart: boolean;
}

export const HoldingAreaActions = ({ goToCheckout, l10n, isAllSoldOut, isNotFullCart }: HoldingAreaActionsProps) => (
  <UitkScrim type={UitkScrimType.BUTTON}>
    <UitkFloatingFullWidthButtonTracked
      className="uitk-cell"
      disabled={isAllSoldOut() || isNotFullCart}
      size={UitkButtonSize.LARGE}
      onClick={goToCheckout}
      rfrr="MultiProp.Checkout"
      linkName="MultiProp Checkout"
    >
      {l10n.formatText('multiProperty.playback.continueToCheckout')}
    </UitkFloatingFullWidthButtonTracked>
  </UitkScrim>
);
